import {validationMixin} from 'vuelidate'

import {MUTATE_SET_SECTION_VALIDATION_STATE} from '../store/modules/active-form-section-validations'

export default {
  data(){
    return{
      vue_validation: {
        admissionDate: false,
        room: false
      }
    }
  },
  mixins: [validationMixin],
  methods: {
    validateSection() {
      this.$v.$touch();
      const value  = this.checkForErrors ? !this.checkForErrors(this.$v) : !this.$v.$error;

      this.$store.commit(MUTATE_SET_SECTION_VALIDATION_STATE, {
        key: this.$options.validationSection,
        value
      })
    }
  },
  mounted() {
    this.validateSection();
  },
  validationSection: ""
}
